import React, { Fragment } from 'react'
import { List, ListItem, OrderedList, Text } from '@chakra-ui/react'
import Link from 'next/link'

export const questionGroups = [
  {
    title: 'เกี่ยวกับ Policy และ PDPA',
    questions: [
      {
        question: 'Privacy Policy คืออะไร',
        answer: (
          <Fragment>
            <Text fontWeight="300">
              Privacy Policy/นโยบายความเป็นส่วนตัว/นโยบายคุ้มครองข้อมูลส่วนบุคคล
              คือ นโยบายที่องค์กรกำหนดแนวปฏิบัติเกี่ยวกับเก็บรวบรวม ใช้
              หรือเปิดเผยข้อมูลส่วนบุคคล เช่น การเก็บ ชื่อ อีเมล เบอร์โทรศัพท์
              เพื่อนำไปทำการตลาด เสนอสินค้าหรือบริการ
              หรือปรับปรุงประสบการณ์การใช้งาน
              ซึ่งโดยส่วนมากแล้วจะจัดทำออกมาในรูปแบบเอกสารบนหน้าเว็บไซต์เพื่อแจ้งให้ผู้ใช้งานทราบ
            </Text>
            <br />
            <Text fontWeight="500">
              รายละเอียดใน Privacy Policy อย่างน้อยจะต้องประกอบไปด้วย
            </Text>
            <List fontWeight="300" styleType="disc">
              <ListItem>ข้อมูลส่วนบุคคลที่มีการจัดเก็บมีอะไรบ้าง</ListItem>
              <ListItem>วิธีการที่จัดเก็บข้อมูลส่วนบุคคลนั้นๆ</ListItem>
              <ListItem>
                การเก็บข้อมูลส่วนบุคคลนั้นมีขั้นตอนอย่างไรบ้าง
              </ListItem>
              <ListItem>วัตถุประสงค์ในการนำข้อมูลไปประมวลผล</ListItem>
              <ListItem>
                รายละเอียดในการเปิดเผยข้อมูลส่วนบุคคล เช่น
                มีการเปิดเผยข้อมูลส่วนบุคคลให้กับใครบ้าง
              </ListItem>
              <ListItem>สิทธิของเจ้าของข้อมูลส่วนบุคคล</ListItem>
              <ListItem>
                ข้อมูลการติดต่อผู้ควบคุมข้อมูลส่วนบุคคล
                และเจ้าหน้าที่คุ้มครองข้อมูลส่วนบุคคล/ตัวแทน
              </ListItem>
            </List>
          </Fragment>
        ),
      },
      {
        question: 'ไม่มี Privacy Policy แล้วจะเป็นอย่างไร',
        answer: (
          <Fragment>
            <Text fontWeight="300">
              ตาม พ.ร.บ.คุ้มครองข้อมูลส่วนบุคคล (PDPA) นั้น
              หากธุรกิจมีการเก็บรวบรวมหรือประมวลผลข้อมูลส่วนบุคคล
              ธุรกิจนั้นๆต้องจัดทำ Privacy Policy มิเช่นนั้นอาจมีความผิดตาม
              พ.ร.บ. คุ้มครองข้อมูลส่วนบุคคล (PDPA) ซึ่งจะได้รับโทษ คือ
            </Text>
            <Text fontWeight="300">
              <strong>โทษทางแพ่ง:</strong> จ่ายสินไหมไม่เกิน 2
              เท่าของสินไหมที่แท้จริง
            </Text>
            <Text fontWeight="300">
              <strong>โทษทางอาญา:</strong> จำคุกไม่เกิน 1 ปีหรือปรับไม่เกิน 1
              ล้านบาท หรือทั้งจำทั้งปรับ
            </Text>
            <Text fontWeight="300">
              <strong>โทษทางปกครอง:</strong> ปรับไม่เกิน 5 ล้านบาท
            </Text>
          </Fragment>
        ),
      },
      {
        question: 'ใครบ้างที่ต้องทำ Privacy Policy',
        answer: (
          <Fragment>
            <Text fontWeight="300">
              ทุกธุรกิจหรือเว็บไซต์ที่ที่มีการเก็บรวมรวม ใช้
              หรือเปิดเผยข้อมูลส่วนบุคคลของผู้ใช้งาน
            </Text>
            <Text fontWeight="500">ตัวอย่างธุรกิจที่ต้องมี Privacy Policy</Text>
            <List fontWeight="300" styleType="disc">
              <ListItem>
                ธุรกิจใดก็ตามที่เก็บข้อมูลลูกค้าหรือผู้ใช้งานไม่ว่าจะเป็น ชื่อ
                อีเมล์ หรือเบอร์โทรศัพท์เพื่อเสนอสินค้า บริการ หรือทำการตลาด
              </ListItem>
              <ListItem>
                เว็บไซต์ที่เก็บข้อมูลการล็อกอินด้วยอีเมลหรือบัญชี Social Network
              </ListItem>
              <ListItem>ธุรกิจขายของออนไลน์ที่เก็บข้อมูลการชำระเงิน</ListItem>
            </List>
          </Fragment>
        ),
      },
      {
        question: 'ทำไมต้องทำ Privacy Policy ตอนนี้',
        answer: (
          <Fragment>
            <Text fontWeight="300">
              เตรียมพร้อมไว้ก่อนดีกว่า การจัดทำ Privacy Policy
              เป็นหนึ่งในหลายรายการที่ต้องทำเพื่อปฏิบัติตาม PDPA{' '}
              <Link href="/blogs/10-steps-pdpa" passHref>
                <a css={{ color: '#2b2b2b', textDecoration: 'underline' }}>
                  อ่าน 10 ขั้นตอนเตรียมความพร้อมรับ PDPA
                </a>
              </Link>
            </Text>
            <Text fontWeight="300">
              ผู้ประกอบการควรเตรียมพร้อมก่อนดำเนินการในขั้นถัดไป
              ก่อนการบังคับใช้กฎหมาย PDPA แบบเต็มรูปแบบในวันที่ 1 มิถุนายน 2565
            </Text>
          </Fragment>
        ),
      },
      {
        question: 'ถ้าบริษัทมีสาขาในต่างประเทศ ต้องเลือก Policy แบบไหน',
        answer: (
          <Fragment>
            <Text fontWeight="300">
              การเลือกจัดทำ Privacy Policy ที่ครอบคลุม PDPA, GDPR หรือ CCPA
              นั้นขึ้นอยู่กับว่าคุณขายสินค้าหรือบริการให้กับกลุ่มลูกค้าในโซนใด
            </Text>
            <br />
            <Text fontWeight="500">
              แต่ถ้าหากบริษัทของคุณจดทะเบียนในประเทศไทยคุณต้องทำตาม PDPA
            </Text>
            <List fontWeight="300" styleType="disc">
              <ListItem>
                หากบริษัทของคุณมีการขายสินค้าหรือบริการให้กับชาวยุโรป
                คุณต้องจัดทำ Policy ที่ครอบคลุมกฎหมาย GDPR ของสหภาพยุโรป
              </ListItem>
              <ListItem>
                หากบริษัทของคุณมีการขายสินค้าหรือบริการให้กับชาวแคลิฟอร์เนีย
                สหรัฐอเมริกา คุณต้องจัดทำ Policy ที่ครอบคลุมกฎหมาย CCPA
              </ListItem>
              <ListItem>
                หากบริษัทคุณขายสินค้าหรือบริการให้กับทั้งชาวไทย ยุโรป และอเมริกา
                คุณต้องจัดทำ Policy ที่ครอบคลุมทั้ง PDPA GDPR และ CCPA
              </ListItem>
              <ListItem>
                หากบริษัทคุณตั้งอยู่ต่างประเทศ
                แต่ขายสินค้าหรือบริการให้กับชาวไทย ก็ต้องปฏิบัติตาม PDPA
                เช่นเดียวกัน
              </ListItem>
            </List>
          </Fragment>
        ),
      },
      {
        question: 'Privacy Policy คุ้มครองข้อมูลของบริษัทหรือบุคคลธรรมดา',
        answer: (
          <Fragment>
            <Text fontWeight="300">
              คุ้มครองข้อมูลส่วนบุคคลของลูกค้าหรือผู้ใช้งานที่เป็นเจ้าของข้อมูลส่วนบุคคลนั้นๆ
              ซึ่งอาจเป็นบุคคลธรรมดาหรือนิติบุคคลก็ได้
            </Text>
          </Fragment>
        ),
      },
      {
        question: 'Policy แต่ละแบบต่างกันอย่างไรและเหมาะกับใคร',
        answer: (
          <Fragment>
            <Text fontWeight="500">Privacy Policy (นโยบายความเป็นส่วนตัว)</Text>
            <Text fontWeight="300">
              คือ คำชี้แจงเกี่ยวกับการเก็บรวบรวม ใช้
              หรือเปิดเผยข้อมูลส่วนบุคคลของผู้ใช้งาน
              เหมาะกับทุกธุรกิจที่มีการประมวลผลข้อมูลส่วนบุคคลของลูกค้าหรือผู้ใช้งาน
              เช่น ชื่อ ที่อยู่ เบอร์โทรศัพท์ เป็นต้น
            </Text>
            <br />
            <Text fontWeight="500">
              HR Privacy Policy (นโยบายความเป็นส่วนตัวสำหรับพนักงาน)
            </Text>
            <Text fontWeight="300">
              คือ คำชี้แจงเกี่ยวกับการเก็บรวบรวม ใช้
              หรือเปิดเผยข้อมูลส่วนบุคคลของพนักงาน
              เหมาะกับทุกธุรกิจที่มีการจ้างงานและเก็บรวบรวมข้อมูลพนักงานภายในองค์กร
              เช่น ชื่อ ที่อยู่ บัตรประชาชน ข้อมูลสุภาพ ประวัติอาชญากรรม เป็นต้น
            </Text>
            <br />
            <Text fontWeight="500">Cookies Policy (นโยบายการใช้คุกกี้)</Text>
            <Text fontWeight="300">
              คือ คำชี้แจงเกี่ยวกับการเก็บรวบรวม ใช้
              หรือเปิดเผยข้อมูลส่วนบุคคลของผู้ใช้งานบนเว็บไซต์
              เหมาะกับเว็บไซต์ที่ใช้คุกกี้เพื่อเก็บข้อมูลทางเทคนิค เช่น
              ข้อมูลการล็อกอิน หรือ พฤติกรรมการใช้งานเว็บไซต์ เป็นต้น
            </Text>
          </Fragment>
        ),
      },
    ],
  },
  {
    title: 'เกี่ยวกับ PDPA Pro',
    questions: [
      {
        question: 'PDPA Pro คืออะไร',
        answer: (
          <Fragment>
            <Text fontWeight="300">
              PDPA Pro คือผู้ให้บริการสร้าง Privacy Policy รวมถึง Policy
              อื่นๆที่เกี่ยวข้องกับการเก็บข้อมูลส่วนบุคคลผ่านทางเว็บไซต์
              โดยผู้ใช้งานเพียงตอบคำถามต่างๆเกี่ยวกับข้อมูลของบริษัท
              วิธีการเก็บรวบรวม ใช้ และเปิดเผยข้อมูลของผู้ใช้งาน
              และผู้รับผิดชอบที่เกี่ยวข้อง
            </Text>
            <br />
            <Text fontWeight="500">
              จากนั้น PDPA Pro จะนำข้อมูลที่ได้มาประมวลผลเป็น Policy
              ที่พร้อมใช้งาน ทั้งในรูปแบบไฟล์สำหรับดาวน์โหลด
              และลิงก์สาธารณะที่โฮสต์โดย PDPA Pro
            </Text>
          </Fragment>
        ),
      },
      {
        question: 'PDPA Pro ตอบโจทย์คุณอย่างไร',
        answer: (
          <Fragment>
            <Text fontWeight="300">
              <List
                fontWeight="300"
                styleType="decimal"
                listStylePosition="inside"
              >
                <ListItem>
                  เป็นการปฏิบัติตามกฎหมาย เพราะ Privacy Policy
                  เป็นสิ่งที่ต้องจัดทำ ตาม พ.ร.บ.คุ้มครองข้อมูลส่วนบุคคล PDPA
                </ListItem>
                <ListItem>
                  <Text d="inline">
                    ประหยัดเวลาคุณได้มากเพราะไม่ต้องทำเอง หากคุณต้องจัดทำ
                    Privacy Policy เอง ความยากลำบากที่คุณต้องเจอคือ
                  </Text>
                  <List styleType="disc" listStylePosition="inside">
                    <ListItem>
                      ต้องศึกษา PDPA
                      ในพระราชกิจจานุเบกษาทั้งหมดอย่างละเอียดด้วยตัวเองเพื่อเป็นข้อมูลในการจัดทำ
                      Policy
                    </ListItem>
                    <ListItem>
                      คุณอาจต้องอ่านตัวอย่างและเทียบ Policy
                      จากหลายๆเว็บไซต์เพื่อนำมาเป็นแบบอย่างในการทำ
                      ซึ่งอาจไม่ได้ครอบคลุมธุรกิจคุณทั้งหมด
                    </ListItem>
                    <ListItem>
                      ต้องเขียน Policy และจัดรูปแบบด้วยตัวเองซึ่งใช้เวลานาน
                    </ListItem>
                    <ListItem>
                      ความไม่แน่ใจว่า Policy
                      ที่ทำออกมานั้นครอบคลุมธุรกิจของคุณหรือไม่{' '}
                    </ListItem>
                    <ListItem>
                      การนำ Policy ขึ้นเว็บไซต์นั้นไม่สามารถทำได้ทันที
                      นักพัฒนาจะต้องนำ Policy ที่คุณร่างไปปรับแต่ง CSS
                      เพื่อให้เข้ากับเว็บไซต์ของคุณ
                    </ListItem>
                  </List>
                  <Text>
                    PDPA Pro รวบรวมข้อกฎหมายต่างๆที่เกี่ยวกับการสร้าง Privacy
                    Policy เรียบเรียงและสร้างเป็นเทมเพลตให้คุณสามารถสร้าง
                    Privacy Policy ได้ด้วยตัวเองโดยตอบคำถามเกี่ยวกับธุรกิจของคุณ
                    ตามขั้นตอนที่เราสร้างให้เข้าใจง่าย ให้คุณได้ Policy
                    ในเวลาไม่กี่นาทีและสามารถนำไปใช้ได้ทันทีเพราะเรามีรูปแบบที่เหมาะกับทุกรูปแบบการใช้งานรวมถึงการนำไปใช้บนเว็บไซต์ด้วย
                  </Text>
                </ListItem>
                <ListItem>
                  ประหยัดค่าใช้จ่ายได้มาก เพราะการจ้างนักกฎหมายเพื่อสร้าง
                  Privacy Policy
                  นั้นมีค่าใช้จ่ายสูงกว่าการใช้ซอฟต์แวร์ที่ให้บริการผ่านแพลตฟอร์ม
                  (SaaS) อย่าง PDPA Pro
                </ListItem>
                <ListItem>
                  <Text d="inline">หมดกังวงเรื่องกฎหมาย เพราะ</Text>
                  <List styleType="disc">
                    <ListItem>
                      เราจะอัพเดท Policy ให้คุณหากกฎหมายมีการเปลี่ยนแปลง
                    </ListItem>
                    <ListItem>
                      Policy ร่างโดยทนายที่ผ่านการอบรมหลักสูตร DPO
                    </ListItem>
                    <ListItem>
                      เรามีผู้เชี่ยวชาญด้านกฎหมายให้ความช่วยเหลือในเวลาทำการ
                    </ListItem>
                  </List>
                </ListItem>
              </List>
            </Text>
          </Fragment>
        ),
      },
      {
        question: 'Policy ที่ได้รับเป็นรูปแบบใดบ้าง',
        answer: (
          <Fragment>
            <Text fontWeight="300">
              คุณจะได้รับ Policy ทั้งเวอร์ชันภาษาไทย และภาษาอังกฤษ
              ในหลากหลายรูปแบบ ผ่านการจัดทำเพียงครั้งเดียว ดังนี้:
            </Text>
            <OrderedList fontWeight="300">
              <ListItem>
                Public URL
                ที่สามารถคัดลอกไปติดตั้งบนเว็บไซต์ได้อย่างสะดวกโดยไม่ต้องสร้างหน้า
                Policy เอง
              </ListItem>
              <ListItem>Plain Text (.txt)</ListItem>
              <ListItem>
                HTML Code เหมาะกับการใช้บนเว็บไซต์กรณีที่ต้องการสร้างหน้า Policy
                ด้วยตนเอง
              </ListItem>
              <ListItem>PDF สำหรับดาวน์โหลด</ListItem>
              <ListItem>Word File (.docx) สำหรับดาวน์โหลด</ListItem>
            </OrderedList>
          </Fragment>
        ),
      },
      {
        question: 'ราคาเท่าไร ชำระเงินอย่างไร',
        answer: (
          <Fragment>
            <Text fontWeight="300">
              เริ่มต้นฟรีสำหรับ Privacy Policy สอดคล้องกับ PDPA
              ฉบับภาษาไทยและอังกฤษ หรือจัดเต็มแบบพรีเมี่ยมในราคา 2,500 บาท HR
              Policy ราคา 1,199 บาท ซึ่งคุณจะได้รับทั้งฉบับภาษาไทยและภาษาอังกฤษ
              คุณสามารถชำระเงินได้ทั้งในนามบุคคลหรือนิติบุคคล
              ทั้งวิธีการโอนผ่านธนาคาร ใช้บัตรเครดิต หรือสแกน QR Code
              เพื่อชำระเงิน
              ซึ่งบริษัทเราจะทำการส่งใบเสร็จรับเงินผ่านอีเมลให้คุณต่อไป
            </Text>
          </Fragment>
        ),
      },
      {
        question: 'เมื่อชำระเงินแล้ว สามารถรับ Policy ได้อย่างไร',
        answer: (
          <Fragment>
            <Text fontWeight="500">หากคุณชำระเงินด้วยบัตรเครดิต:</Text>
            <Text fontWeight="300">
              คุณจะได้รับ Policy ทันทีผ่านหน้าเว็บไซต์เมื่อชำระเงินสำเร็จ
            </Text>
            <Text fontWeight="500">หากคุณชำระเงินด้วยการโอน:</Text>
            <Text fontWeight="300">
              หลังจากที่คุณชำระเงินและอัปโหลดหลักฐานการโอนเงินแล้ว
              เราจะทำการยืนยันหลักฐานการโอนและทำการ Approve Policy ภายใน 2
              วันทำการ จากนั้นเราจะแจ้งผลการ Approve Policy
              ผ่านทางอีเมลพร้อมกับวิธีการรับ Policy หรือคุณสามารถรับ Policy
              ได้ด้วยตนเองผ่านทางแดชบอร์ดของ PDPA Pro
            </Text>
          </Fragment>
        ),
      },
      {
        question:
          'สามารถออกใบกำกับภาษีในนามนิติบุคคลได้หรือไม่ และสามารถหักภาษี ณ ที่จ่ายได้หรือไม่',
        answer: (
          <Text fontWeight="300">
            ได้ เราสามารถออกใบกำกับภาษีให้คุณได้
            โดยหลังจากชำระเงินแล้วเราจะส่งสำเนาใบกำกับภาษีให้ทางอีเมลล์ที่คุณลงทะเบียนไว้ภายใน
            2 วันทำการ และส่งเอกสารใบกำกับภาษีตัวจริงไปตาม billing address
            ของคุณภายในระยะเวลาไม่เกิน 1 อาทิตย์
            (หากต้องการให้จัดส่งไปที่อยู่หรืออีเมลอื่น โปรดแจ้งเราผ่านทาง chat
            box ที่อยู่มุมขวาล่าง โดยระบุชื่อของ Policy ที่สั่งซื้อ
            และอีเมลที่ต้องการให้จัดส่ง
            และเนื่องจากเราได้รับสิทธิยกเว้นภาษีเงินได้นิติบุคคลตาม มาตรา ๓๑ ของ
            พระราชบัญญัติส่งเสริมการลงทุน พ.ศ.2520
            จากสำนักงานคณะกรรมการส่งเสริมการลงทุน
            ดังนั้นผู้ใช้บริการจึงไม่ต้องทำการหักภาษี ณ ที่จ่าย
          </Text>
        ),
      },
      {
        question: 'ได้ Policy ไปแล้วสามารถนำไปใช้ได้ทันทีหรือไม่',
        answer: (
          <Fragment>
            <Text fontWeight="300">
              สามารถนำ Policy ที่ได้ไปใช้ได้ทันที
              อย่างไรก็ตามควรให้ผู้เชี่ยวชาญทางกฎหมายช่วยตรวจสอบเนื้อหาของ
              Policy ที่ได้อีกครั้งว่าครอบคลุมบริบทธุรกิจของคุณหรือไม่
            </Text>
          </Fragment>
        ),
      },
      {
        question: 'โฮสต์ Policy คืออะไร',
        answer: (
          <Fragment>
            <Text fontWeight="300">
              เราดูแลและติดตามการเปลี่ยนแปลงหรือปรับเปลี่ยนข้อกฎหมายต่างๆที่ส่งผลกระทบต่อส่วนประกอบและโครงสร้างของ
              Policy และจะทำการอัพเดท Policy ของคุณเพื่อให้สอดคล้องกับกฎหมาย
              เมื่อข้อกฎหมายมีการเปลี่ยนแปลงหรือมีความชัดเจนขึ้น
              โดยเราจะไม่ยุ่งเกี่ยวกับข้อมูลบริษัทของคุณ
            </Text>
            <Text fontWeight="300">
              โดยเราจะทำการอัพเดทผ่านลิงก์ Policy
              ออนไลน์ของคุณและแจ้งเตือนคุณหากมีการอัพเดท
            </Text>
          </Fragment>
        ),
      },
      {
        question: 'PDPA Pro จ่ายครั้งเดียวจบหรือเป็น Subscription',
        answer: (
          <Fragment>
            <Text fontWeight="300">
              จ่ายครั้งเดียวจบ Policy ของเราเป็นการขายแบบ one time purchase
              ไม่ต้องจ่ายเป็นรายเดือน คุณก็ได้ Policy ไปใช้งานได้ตลอดไป
              เข้าถึงได้ทุกเมื่อผ่านแดชบอร์ด
              พร้อมอัปเดตให้เมื่อกฎหมายมีการเปลี่ยนแปลง
            </Text>
          </Fragment>
        ),
      },
    ],
  },
]
